<template>
  <div :class="dialog ? '' : 'card'">
    <component :is="selectedComponent"
      :visible.sync="meetingDialog1"
      :key="meetingDialogKey"
      :style="meetingDialog? { width: '700px', height: '350px' }:''"
      header="Result"
      :modal="meetingDialog?true:''"
      class="p-fluid"
      id="meetingDialog"
      @keyup="keyMonitor"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field col">
          <label for="contact">Activity Result</label>
          <Dropdown
            v-model="result"
            :options="activityResults"
            optionLabel="resultDesc"
            dataKey="id"
            placeholder="Select Activity Result"
            :showClear="true"
            :class="{ 'p-invalid': submitted && !thisActivity.activityResult }"
          />
          <small class="p-invalid" v-if="submitted && !thisActivity.activityResult"
            >Activity Result is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field col">
          <label for="notes">Result notes</label>
          <Textarea 
            v-model.trim="thisActivity.notes" 
            :autoResize="true" 
            :rows="getRowSize()"
            required="false"
            autofocus
            :class="{ 'p-invalid': submitted && !thisActivity.notes }"
          />
          <small class="p-invalid" v-if="submitted && !thisActivity.notes"
            >Notes are required.</small
          >
        </div>
      </div>
      <div class="p-grid p-formgrid" v-if="showMore">
        <div class="p-field col-12 mb-2 col-md-6 lg:mb-0">
          <label for="contact">Activity Types</label>
          <Dropdown
            v-model="thisActivity.activityType"
            :options="activityTypes"
            optionLabel="activityTypeName"
            dataKey="id"
            placeholder="Select Activity Type"
            :showClear="true"
            :class="{ 'p-invalid': submitted && !thisActivity.activityType }"
          />
          <small class="p-invalid" v-if="submitted && !thisActivity.activityType"
            >Activity Type is required.</small
          >
        </div>
        <div class="col-12 mb-2 col-md-6 lg:mb-0">
          <label for="contact">Subject</label>
          <InputText
            id="subject"
            v-model.trim="thisActivity.subject"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !thisActivity.subject }"
          />
          <small class="p-invalid" v-if="submitted && !thisActivity.subject"
            >Subject is required.</small
          >
        </div>
      </div>
      <br />
      <br />
      <br />
      <div class="p-formgrid p-grid" v-if="showMore">
        <div class="p-field col-12 mb-2 col-md-4 lg:mb-0">
          <label for="startDate">Start Date*</label>
          <Calendar
            id="startDate"
            v-model="startDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !thisActivity.startDate }"
            :disabled="isDisabled()"
          />
          <small class="p-invalid" v-if="submitted && !thisActivity.startDate"
            >Start Date is required.</small
          >
          <br />
          <small class="p-invalid" v-if="showStartDateError"
            >Please choose a Date/Time in the future.</small
          >
        </div>
        <div class="p-field col-12 mb-2 col-md-4 lg:mb-0">
          <label for="startTime">Start Time*</label>
          <Calendar
            id="startTime"
            v-model="startTime"
            :showIcon="true"
            :showTime="true"
            :timeOnly="true"
            hourFormat="24"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !thisActivity.startTime }"
            :disabled="isDisabled()"
          />
          <small class="p-invalid" v-if="submitted && !thisActivity.startTime"
            >Start Time is required.</small
          >
          <br />
          <small class="p-invalid" v-if="showStartDateError"
            >Please choose a Date/Time in the future.</small
          >
        </div>
        <div class="p-field col-12 mb-2 col-md-4 lg:mb-0">
          <label for="endDate">Duration in minutes</label>
          <InputNumber 
            id="duration"
            v-model.trim="thisActivity.duration"
            required="false"
            :class="{ 'p-invalid': submitted && !thisActivity.duration }"
          />
          <small class="p-invalid" v-if="submitted && !thisActivity.duration"
            >Duration in minutes is required.</small
          >
        </div>
      </div>
      
      <template #footer>
        <div class="p-grid" style="padding-top: 10px;">
          <div class="p-lg-4 p-md-3 p-sm-3">
          </div>
          <div class="p-lg-4 p-md-3 p-sm-3">
          </div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-danger"
              @click="$emit('close')"
              style="width: 100px;"
            />
          </div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <ProgressSpinner 
              v-if="sendingRequest"
              style="width:25px; height:25px; width: 100px;" 
              strokeWidth="5" 
              fill="#EEEEEE" 
              animationDuration=".5s"
            />
            <Button
              v-else
              label="Save"
              icon="pi pi-check"
              class="p-button-success"
              @click="save"
              style="width: 100px;"
            />
          </div>
        </div>
      </template>
    </component>
    <div class="flex justify_space_between my-1">
      <div>
      </div>
      <div v-if="!dialog"
        style="width: 250px; display: flex; justify-content: flex-end;">
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;" 
          strokeWidth="5" 
          fill="#EEEEEE" 
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          style="width: 100px;"
          @click="save"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActivityService from "@/service/ActivityService";

export default {
  created() {
    this.activityService
      .getAllActiveActivityResults()
      .then((data) => (this.activityResults = data))
      .catch((e) => {
        
          
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting activity results",
        //   life: 5000,
        // })
        this.$store.dispatch('addErrorMessage', {
          severity: 'error',
          content: 'Some data was not loaded from "activeActivityResults"'
        })
      });
    this.activityService
      .getAllActivityTypes()
      .then((data) => (this.activityTypes = data))
      .catch((e) => {
        
          
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting activity types",
        //   life: 5000,
        // })
        this.$store.dispatch('addErrorMessage', {
          severity: 'error',
          content: 'Some data was not loaded from "activityTypes"'
        })
      });
  },
  props: {
    meetingDialog: {
      type: Boolean,
      required: true
    },
    dialog: {
      type: Boolean,
      default: true
    },
    reload: {
      type: Number,
      required: false
    },
    activity: {
      type: Object,
      required: true
    },
    sendingRequest: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    activityService: new ActivityService(),
    comment: '',
    submitted: false,
    meetingDialogKey: 0,
    activityResults: [],
    activityTypes: [],
    thisActivity: {},
    showMore: false,
    result: {},
    startDate: null,
    startTime: null,
    showStartDateError: false,
  }),
  computed: {
    meetingDialog1: {
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      },
      get() {
        return this.meetingDialog
      }
    },
    selectedComponent() {
        if(this.dialog)
        {
            return 'Dialog'
        }
        else {
            return 'div'
        }
    }
  },
  watch: {
    startDate(val) {
      if (!this.isDisabled()) {
        this.analyzineStartTime()
      } else {
        if (val) {
          let date = new Date(val), year = date.getFullYear(), month = date.getMonth(), day = date.getDate(), hours = date.getHours(), minutes = date.getMinutes()
          this.thisActivity.startDate = new Date(year, month, day + this.result.daysFromNow, hours, minutes)
        }
      }
    },
    startTime (val) {
      if (!this.isDisabled()) {
        this.analyzineStartTime()
      } else {
        if (val) {
          let a = val.split(':'), date = new Date(), year = date.getFullYear(), month = date.getMonth(), day = date.getDate()
          this.thisActivity.startTime = new Date(year, month, day, a[0], a[1])
        }
      }
    },
    result(val) {
      
      
      let a = document.getElementById('meetingDialog')
      if (a) {
        if (val && val.id == 4 && this.dialog) {
          a.style.height = '590px'
        } else if (val && val.id == 4 && !this.dialog){
          a.style.height = '720px'
        }
        else {
          a.style.height = '350px'
        }
      }

      this.thisActivity.activityResult = val
      if (val && val.createActivity) {
      // if (val && val.id) {
        this.showMore = true

        
        if (this.isDisabled()) {
          this.startDate = this.activity.startDate
          this.startTime = this.activity.startTime
        } else {
          this.startDate = ''
          this.startTime = ''
        }
      } else {
        this.showMore = false
      }
    },
    activity(val) {
      this.thisActivity = {...val}
    },
    reload() {
      this.refreshComponent()
    }
  },
  methods: {
    keyMonitor(event) {
      // 
      if (event.key === 'Tab') {
        let a = document.activeElement
        if (a) {

          let b = document.getElementsByClassName('p-datepicker p-component')
          b.forEach(c => {
            let found = false // when moving from date to date (date === time)
            let found1 = true // when going from date to dropdown (specially in primevue)

            c.parentElement.children.forEach(d => {
              // 

              if (d.id === a.id) {
                found = true
              }
              if (d.id && a.parentElement.parentElement.id && d.id !== a.parentElement.parentElement.id) {
                found1 = false
              }
            })
            // 
            if (!found || !found1) {
              c.style.visibility = "hidden";
            }
          })
        }
        
      }

    },
    isDisabled() {
      return !(this.result && this.result.daysFromNow === 0)
    },
    refreshComponent() {
      this.thisActivity = {}
      this.showMore = false
      this.result = {}
      this.startDate = null
      this.startTime = null
      this.showStartDateError = false
      this.submitted = false
      this.sendingRequest = false
      this.meetingDialogKey++
    },
    analyzineStartTime() {
      if (this.startDate) {
        let year = this.startDate.getFullYear(), month = this.startDate.getMonth(), date = this.startDate.getDate(), hours = 0, minutes = 0

        try {
          hours = this.startTime.getHours(), minutes = this.startTime.getMinutes()
        } catch (e) {}

        let day = new Date(year, month, date, hours, minutes)
        // 
        if (day.getTime() > new Date().getTime()) {
          this.showStartDateError = false
          this.thisActivity.startDate = this.startDate
          this.thisActivity.startTime = this.startTime
        } else {
          this.showStartDateError = true
          this.thisActivity.startDate = ''
          this.thisActivity.startTime = ''
        }
        // 
      }
    },
    getRowSize() {
      if (this.notes) {
        let len = this.notes.split('\n')
        return (Math.floor(this.notes.length / 100) + len.length).toString()
      } else {
        return '2'
      }
    },
    save() {
      this.submitted = true
      
      if (
        this.thisActivity.activityResult &&
        this.thisActivity.activityResult.id &&
        this.thisActivity.activityResult.resultCode === "CUSTOM"
      ) {

        if (
          this.thisActivity.activityType &&
          this.thisActivity.activityType.id &&
          this.thisActivity.notes &&
          this.thisActivity.startDate &&
          this.thisActivity.startTime &&
          this.thisActivity.duration &&
          this.thisActivity.subject
        ) {
        
          let ms = this.thisActivity.duration * 60000, 
            year = this.thisActivity.startDate.getFullYear(), 
            month = this.thisActivity.startDate.getMonth(), 
            date = this.thisActivity.startDate.getDate(), 
            hours = this.thisActivity.startTime.getHours(), 
            minutes = this.thisActivity.startTime.getMinutes(), 
            startFullTime = new Date(year, month, date, hours, minutes),
            startFullTimeInMS = startFullTime.getTime(),
            endFullTimeInMS = startFullTimeInMS + ms,
            endFullTime = new Date(endFullTimeInMS);

          // 
  
          if (endFullTime) {
            if ((month + 1).toString().length === 1) {
              month = '0' + (month + 1).toString()
            }
            if (date.toString().length === 1) {
              date = '0' + date.toString()
            }
            if (hours.toString().length === 1) {
              hours = '0' + hours.toString()
            }
            if (minutes.toString().length === 1) {
              minutes = '0' + minutes.toString()
            }

            this.thisActivity.startDate = `${date}/${month}/${year}`
            this.thisActivity.startTime = `${hours}:${minutes}`

            year = endFullTime.getFullYear(), month = endFullTime.getMonth(), date = endFullTime.getDate(), hours = endFullTime.getHours(), minutes = endFullTime.getMinutes()

            if ((month + 1).toString().length === 1) {
              month = '0' + (month + 1).toString()
            }
            if (date.toString().length === 1) {
              date = '0' + date.toString()
            }
            if (hours.toString().length === 1) {
              hours = '0' + hours.toString()
            }
            if (minutes.toString().length === 1) {
              minutes = '0' + minutes.toString()
            }

            this.thisActivity.endDate = `${date}/${month}/${year}`
            this.thisActivity.endTime = `${hours}:${minutes}`
                        
            this.$emit('save', this.thisActivity)
          }
          
        }

      } else if (
        this.thisActivity.activityResult &&
        this.thisActivity.activityResult.id &&
        this.thisActivity.notes
      ) {
        this.$emit('save', this.thisActivity)
      }
    }
  }
}
</script>

<style>

</style>